import { GET_BOARD_CERTIFICATIONS_ACTION } from '@/store/boardCertications';
import { GET_SOCIETY_CERTIFYING_BOARDS_ACTION } from '@/store/societyCertifyingBoards';
import { GET_CERTIFYING_BOARDS_ACTION } from '@/store/certifyingBoards';

export default {
  created: async function () {
    try {
      this.$wait.start(this.loaderId);
      const arr = [];
      if (!(this.$store.state.boardCertifications.items || []).length) {
        arr.push(this.$store.dispatch(GET_BOARD_CERTIFICATIONS_ACTION));
      }
      if (!(this.$store.state.societyCertifyingBoards.items || []).length) {
        arr.push(this.$store.dispatch(GET_SOCIETY_CERTIFYING_BOARDS_ACTION));
      }
      if (!(this.$store.state.certifyingBoards.items || []).length) {
        arr.push(this.$store.dispatch(GET_CERTIFYING_BOARDS_ACTION));
      }
      await Promise.all(arr);
    } catch (error) {
      process.env.NODE_ENV !== 'production' && console.error(error);
      this.$toasted.show('Some error occurs', {
        type: 'error',
        duration: 3000,
      });
    } finally {
      this.$wait.end(this.loaderId);
    }
  },
};
